export const RequestSession = 'REQUEST_SESSION'
export const RequestSessionSuccess = 'REQUEST_SESSION_SUCCESS'
export const RequestSessionFailure = 'REQUEST_SESSION_FAILURE'
export const CreateSession = 'CREATE_SESSION'
export const DestroySession = 'DESTROY_SESSION'
export const HideDuo = 'HIDE_DUO'
export const ShowDuo = 'SHOW_DUO'

export const RequestPriorityConvSums =
  'REQUEST_PRIORITY_CONVERSATIONS_SUMMARIES'
export const RequestAllConvSums = 'REQUEST_ALL_CONVERSATION_SUMMARIES'
export const RequestConvSumsFailure = 'REQUEST_CONVERSATION_SUMMARIES_FAILURE'
export const ReceivedConvSums = 'RECEIVED_CONVERSATION_SUMMARIES'
export const ReceivedPriorityConvSums =
  'RECEIVED_PRIORITY_CONVERSATIONS_SUMMARIES'
export const RemoveConvSum = 'REMOVE_CONVERSATION_SUMMARY'
export const AddPriorityConvSum = 'ADD_PRIORITY_CONVERSATION_SUMMARY'
export const RemovePriorityConvSum = 'REMOVE_PRIORITY_CONVERSATION_SUMMARY'

export const RequestAssignedConvSums = 'REQUEST_ASSIGNED_CONVERSATION_SUMMARIES'
export const ReceivedAssignedConvSums =
  'RECEIVED_ASSIGNED_CONVERSATION_SUMMARIES'
export const RequestAssignedConvSumsFailure =
  'REQUEST_ASSIGNED_CONVERSATION_SUMMARIES_FAILURE'

export const RequestConvAssignment = 'REQUEST_CONVERSATION_ASSIGNMENT'
export const ReceivedConvAssignment = 'RECEIVED_CONVERSATION_ASSIGNMENT'
export const RequestConvAssignmentFailure =
  'REQUEST_CONVERSATION_ASSIGNMENT_FAILURE'
export const GroupMessagesByDate = 'GROUP_MESSAGES_BY_DATE'

export const RequestCurrentConv = 'REQUEST_CURRENT_CONVERSATION'
export const ReceivedCurrentConv = 'RECEIVED_CURRRENT_CONVERSATION'
export const RequestCurrentConvFailure = 'REQUEST_CURRENT_CONVERSATION_FAILURE'
export const DestroyCurrentConv = 'DESTROY_CURRENT_CONVERSATION'
export const UpdatingCurrentConv = 'UPDATING_CURRENT_CONVERSATION'
export const AddNewMessage = 'ADD_NEW_MESSAGE_TO_CURRENT_CONVERSATION'
export const UpdateMessage = 'UPDATE_MESSAGE'
export const ToggleReassignConvVisible = 'TOGGLE_REASSIGN_CONVERSATION_VISIBLE'
export const ReassignConversationSuccess = 'REASSIGN_CONVERSATION_SUCCESS'

export const PostMessage = 'POST_MESSAGE'
export const PostMessageSuccess = 'POST_MESSAGE_SUCCESS'
export const PostMessageFailure = 'POST_MESSAGE_FAILURE'

export const ShowCreateTicket = 'SHOW_CREATE_TICKET'
export const SubmitCreateTicket = 'SUBMIT_CREATE_TICKET'
export const SubmitCreateTicketSuccess = 'SUBMIT_CREATE_TICKET_SUCCESS'
export const SubmitCreateTicketFailure = 'SUBMIT_CREATE_TICKET_FAILURE'

export const HideModal = 'HIDE_MODAL'
export const ShowAnalyticsModal = 'SHOW_ANALYTICS_MODAL'
export const ShowResolveConv = 'SHOW_RESOLVE_CONVERSATION'
export const SubmitResolveConv = 'SUBMIT_RESOLVE_CONVERSATION'
export const SubmitResolveConvSuccess = 'SUBMIT_RESOLVE_CONVERSATION_SUCCESS'
export const SubmitResolveConvFailure = 'SUBMIT_RESOLVE_CONVERSATION_FAILURE'

export const RequestConversationUnassign = 'REQUEST_CONVERSATION_UNASSIGN'
export const ReceivedConversationUnassignSuccess =
  'RECEIVED_CONVERSATION_UNASSIGN_SUCCESS'
export const ReceivedConversationUnassignFailure =
  'RECEIVED_CONVERSATION_UNASSIGN_FAILURE'

export const UploadingCSV = 'UPLOADING_CSV'
export const UploadingSuccess = 'UPLOAD_CSV_SUCCESS'
export const UploadingFailure = 'UPLOAD_CSV_FAILURE'

export const UploadingDocument = 'UPLOADING_DOCUMENT'
export const UploadingDocumentSuccess = 'UPLOAD_DOCUMENT_SUCCESS'
export const UploadingDocumentFailure = 'UPLOAD_DOCUMENT_FAILURE'

export const HideNotification = 'HIDE_NOTIFICATION'
export const ShowNotification = 'SHOW_NOTIFICATION'

export const SetLoading = 'SET_LOADING'
// Vehicle options for year/make/model/trim dropdowns
export const RequestVehicleOptions = 'REQUEST_VEHICLE_OPTIONS'
export const RequestVehicleOptionsSuccess = 'REQUEST_VEHICLE_OPTIONS_SUCCESS'
export const RequestVehicleOptionsFailure = 'REQUEST_VEHICLE_OPTIONS_FAILURE'
